import { render, staticRenderFns } from "./SwiperNavigation.vue?vue&type=template&id=5df8e7f5&scoped=true&"
import script from "./SwiperNavigation.vue?vue&type=script&lang=js&"
export * from "./SwiperNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SwiperNavigation.vue?vue&type=style&index=0&id=5df8e7f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8e7f5",
  null
  
)

export default component.exports